import React from "react";

import ConditionImage1 from "../../assets/img/condition-1.png";
import ConditionImage2 from "../../assets/img/condition-2-3.png";
import ConditionImage3 from "../../assets/img/condition-3-4.png";
import ConditionImage5 from "../../assets/img/condition-5.png";
import { scrollToElement } from "../../tools";

export default function Condition(props) {
  function onClick() {
    if (props.conditionButtons && props.conditionButtons.current) {
      scrollToElement(props.conditionButtons.current);
    }
  }

  return (<>
    <div>
      <div className="row">
        <div className="col-6 pr-0 mt-1">
          <img 
            src={ConditionImage1} className="img-fluid mr-1" alt="Condition 1"
            onClick={() => onClick()}
          />
          <span className="circle-over-image">1</span>
        </div>
        <div className="col-6 pl-0 mt-1">
          <img 
            src={ConditionImage2} className="img-fluid ml-1" alt="Condition 2-3"
            onClick={() => onClick()}
          />
          <span className="circle-over-image circle-over-image--wide circle-over-image--right">2-3</span>
        </div>
      </div>

      <div className="row">
        <div className="col-6 pr-0 mt-1">
          <img 
            src={ConditionImage3} className="img-fluid mr-1" alt="Condition 3-4"
            onClick={() => onClick()}
          />
          <span className="circle-over-image circle-over-image--wide">3-4</span>
        </div>
        <div className="col-6 pl-0 mt-1">
          <img 
            src={ConditionImage5} className="img-fluid ml-1" alt="Condition 5"
            onClick={() => onClick()}
          />
          <span className="circle-over-image circle-over-image--right">5</span>
        </div>
      </div>
    </div>
    <div className="mt-5">
      <div
        className="text-center"
        onClick={() => onClick()}
      >
        <b>1 - prasta 5 - prabangi</b>
      </div>
    </div>
  </>);
}
